class SidePanelEducationController {
  constructor(JPMCService, UserDataService) {
    this.allEducation = JPMCService.getConfig().education;
    this.minimumEducation = JPMCService.getJobById(this.jobId).education.minimum;
    this.userEducation = UserDataService.education;
  }
  checkEducationRequirement(index) {
    let minimumEducationIndex = this.allEducation.findIndex((education) => {
      return education.id === this.minimumEducation;
    });
    if (minimumEducationIndex > -1 && index <= minimumEducationIndex) {
      return true;
    } else {
      return false;
    }
  }
}

SidePanelEducationController.$inject = ['JPMCService', 'UserDataService'];

export default SidePanelEducationController;



// WEBPACK FOOTER //
// ./src/components/sidePanelEducation/sidePanelEducation.controller.js